module.exports = __webpack_public_path__ + "assets/wink@2x.png";